export default "__VITE_ASSET__D5XVjrn9__"